import requests from '@/utils/requests';

/**
 * 用户Ldap登录接口
 * @param {*} data
 */
export function userLdapLogin(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userLdapLogin',
    method: 'post',
    data
  });
}

/**
 * 用户飞书登录接口
 * @param {*} data
 */
export function userFeiShuLogin(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userFeiShuLogin',
    method: 'post',
    data
  });
}

/**
 * 用户Token验证接口
 * @param {*} data
 */
export function verifyToken(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/verifyToken',
    method: 'post',
    data
  });
}

/**
 * 用户飞书登录接口
 * @param {*} data
 */
export function logout(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/logout',
    method: 'post',
    data
  });
}

/**
 * 用户列表接口
 * @param {*} data
 */
export function userList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userList',
    method: 'post',
    data
  });
}

/**
 * 添加用户接口
 * @param {*} data
 */
export function userAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userAdd',
    method: 'post',
    data
  });
}

/**
 * 修改用户接口
 * @param {*} data
 */
export function userModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userModify',
    method: 'post',
    data
  });
}

/**
 * 删除用户接口
 * @param {*} data
 */
export function userDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userDelete',
    method: 'post',
    data
  });
}

/**
 * 修改用户状态接口
 * @param {*} data
 */
export function userStatusModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/userStatusModify',
    method: 'post',
    data
  });
}

/**
 * 角色列表接口
 * @param {*} data
 */
export function roleList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/roleList',
    method: 'post',
    data
  });
}

/**
 * 添加角色接口
 * @param {*} data
 */
export function roleAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/roleAdd',
    method: 'post',
    data
  });
}

/**
 * 修改角色接口
 * @param {*} data
 */
export function roleModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/roleModify',
    method: 'post',
    data
  });
}

/**
 * 角色详情接口
 * @param {*} data
 */
export function roleDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/roleDetail',
    method: 'post',
    data
  });
}

/**
 * 删除角色接口
 * @param {*} data
 */
export function roleDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/roleDelete',
    method: 'post',
    data
  });
}

/**
 * 权限列表接口
 * @param {*} data
 */
export function permissionList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/PermissionList',
    method: 'post',
    data
  });
}

/**
 * 删除权限接口
 * @param {*} data
 */
export function permissionDelete(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/PermissionDelete',
    method: 'post',
    data
  });
}

/**
 * 添加权限接口
 * @param {*} data
 */
export function permissionAdd(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/PermissionAdd',
    method: 'post',
    data
  });
}

/**
 * 修改权限接口
 * @param {*} data
 */
export function permissionModify(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/PermissionModify',
    method: 'post',
    data
  });
}

/**
 * 用户权限列表接口
 * @param {*} data
 */
export function userPermission(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UserPermissions',
    method: 'post',
    data
  });
}

/**
 * 修改用户绑定权限接口
 * @param {*} data
 */
export function userBindRole(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UserBindRole',
    method: 'post',
    data
  });
}

/**
 * 将用户移除项目接口
 * @param {*} data
 */
export function userUnbindRole(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UserUnbindProject',
    method: 'post',
    data
  });
}

/**
 * 修改用户绑定权限接口
 * @param {*} data
 */
export function userRoleList(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UserRoleList',
    method: 'post',
    data
  });
}

/**
 * 修改用户绑定权限接口
 * @param {*} data
 */
export function usersBindProject(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UsersBindProject',
    method: 'post',
    data
  });
}

/**
 * 查询未绑定项目用户接口
 * @param {*} data
 */
export function usersUnboundProject(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/UsersUnboundProject',
    method: 'post',
    data
  });
}

/**
 * 用户飞书登录接口
 * @param {*} data
 */
export function getPersonalInfo(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/getPersonalInfo',
    method: 'post',
    data
  });
}

/**
 * 用户飞书登录接口
 * @param {*} data
 */
export function addPersonalInfo(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/addPersonalInfo',
    method: 'post',
    data
  });
}

/**
 * 用户飞书登录接口
 * @param {*} data
 */
export function modifyPersonalInfo(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/auth/modifyPersonalInfo',
    method: 'post',
    data
  });
}

/**
 * 获取飞书文档验签
 * @param {*} data
 */
export function getSignature(data) {
  return requests({
    serviceName: 'user-service',
    url: '/api/auth/getUserSignature',
    method: 'post',
    data
  });
}
